module.exports = __webpack_public_path__ + "img/1436259755.6fd1bb73.jpg";